<nb-card>
    <nb-card-header>{{ title }}</nb-card-header>
    <nb-card-body>{{ text }}</nb-card-body>
    <nb-card-footer>
        <button class="m-1 float-right" *ngIf="okButton" nbButton type="button" status="success" (click)="ok()">{{okButton}}</button>
        <button class="m-1 float-right" *ngIf="cancelButton" nbButton type="button" status="danger" (click)="dialogRef.close()">{{cancelButton}}</button>
    </nb-card-footer>
</nb-card>